import { cn } from '@poseidon/components/cn';
import { Alerts } from '@poseidon/components/StrokeIcons';

import type { StepIssue } from '~/components/Sequence/sequenceSteps';

/**
 * A richer tooltip body for a step's validation {@link StepIssue} — a severity icon + the message,
 * wrapped to a readable width so it reads as multiple lines instead of one long cut-off strip. Tinted by
 * level: amber for an advisory `warning`, red for a blocking `error`. Passed as the `tooltip` node to a
 * node's Tooltip; `issue.message` stays the single source of the text (`whitespace-normal` overrides the
 * tooltip bubble's default `nowrap`).
 */
export function SequenceStepIssueTooltip({ issue }: { issue: StepIssue }) {
  const warning = issue.level === 'warning';
  return (
    <span className="flex max-w-[15rem] items-start gap-1.5 whitespace-normal text-left leading-snug">
      <Alerts.AlertTriangle className={cn('mt-px size-3.5 shrink-0', warning ? 'text-amber-400' : 'text-red-400')} />
      <span>{issue.message}</span>
    </span>
  );
}
